import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateFormat } from '@lx/shared/i18n';
import { DatePipe, LocalizeAndPluralizePeriodPipe } from '@lx/shared/ui/pipes';
import { getDateFromString } from '@lx/shared/utils';
import { ListboxModule } from 'primeng/listbox';
import { ListBoxComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { FixedDate } from '../../types';

@Component({
  standalone: true,
  selector: 'lx-fixed-date-selector',
  templateUrl: './fixed-date-selector.component.html',
  styleUrls: ['./fixed-date-selector.component.scss'],
  imports: [ListboxModule, FormsModule, DatePipe, NgIf, LocalizeAndPluralizePeriodPipe, ListBoxComponent],
})
export class FixedDateSelectorComponent implements OnChanges {
  @Input() fixedDates: FixedDate[] = [];
  @Input() selectedFixedDate: FixedDate | undefined;
  @Output() selectedFixedDateChange = new EventEmitter<FixedDate>();

  fixedDate: FixedDate | undefined;

  protected readonly dateFormat = DateFormat;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fixedDates']?.currentValue) {
      this.fixedDates = this.sortFixedDates(this.fixedDates);
    }

    this.fixedDate = this.findMatchingDate();
  }

  triggerSelectedDateChanged(): void {
    this.selectedFixedDateChange.emit(this.fixedDate);
  }

  private findMatchingDate(): FixedDate | undefined {
    return this.fixedDates?.find(({ date }) => date === this.selectedFixedDate?.date);
  }

  private sortFixedDates(fixedDates: FixedDate[]): FixedDate[] {
    return fixedDates?.slice()?.sort((a: FixedDate, b: FixedDate) => getDateFromString(a?.date).getTime() - getDateFromString(b?.date).getTime());
  }
}
